import React from "react";
import {
    HierarchyPath,
    TreeCheckboxGroup,
    TreeNode,
    TreeCheckboxGroupProps,
} from "../../../../../../components/TreeCheckboxGroup";
import { defineMessages } from "react-intl";
import EmptyState from "../../../../../Workmodes/Playlist/Teacher/EditPlaylist/TeacherPlaylistSend/Components/EmptyState";
import { LegacyLoader } from "../../../../../../components/Loader/Loader";

type Props = {
    students?: Record<string, TreeNode>;
    classroomIds: string[];
    pickedStudents: HierarchyPath[];
    onStudentPick: (path: HierarchyPath) => void;
} & Pick<TreeCheckboxGroupProps, "startingHeadingLevel">;

const StudentPicker = ({
    students,
    classroomIds,
    pickedStudents,
    onStudentPick,
    startingHeadingLevel = 2,
}: Props) => {
    if (!students) return <LegacyLoader />;
    if (!hasStudents(students)) return <EmptyState />;

    return (
        <TreeCheckboxGroup
            nodes={students}
            rootChildrenIds={classroomIds}
            checkedLeaves={pickedStudents}
            onCheckNode={onStudentPick}
            selectBranchLabel={selectBranchLabel}
            selectLeafLabel={selectLeafLabel}
            // Simulate starting padding
            startingHeadingLevel={startingHeadingLevel}
            accentColor="var(--element-teacher-default)"
        />
    );
};
export default StudentPicker;

const hasStudents = (students: Record<string, TreeNode>) =>
    Object.values(students).some((node) => !!node.childrenIds?.length);

const messages = defineMessages({
    checkClassroom: {
        id: "workmode-playlist-checkClassroom",
        defaultMessage: "Add all students from {branch} to the recipients list",
    },
    uncheckClassroom: {
        id: "workmode-playlist-uncheckClassroom",
        defaultMessage:
            "Remove all students from {branch} from the recipients list",
    },
    checkStudent: {
        id: "workmode-playlist-checkStudent",
        defaultMessage: "Add {label} to the recipients list",
    },
    uncheckStudent: {
        id: "workmode-playlist-uncheckStudent",
        defaultMessage: "Remove {label} from the recipients list",
    },
});

const selectBranchLabel = (status: boolean | "mixed") => {
    switch (status) {
        case true:
            return messages.uncheckClassroom;
        case false:
        case "mixed":
            return messages.checkClassroom;
    }
};
const selectLeafLabel = (status: boolean) => {
    switch (status) {
        case true:
            return messages.uncheckStudent;
        case false:
            return messages.checkStudent;
    }
};
